const generateArrayOfNumbers = maxNumber => Array.from(Array(maxNumber).keys())

export default generateArrayOfNumbers
